(ns frontend.ui.component.grid.style
  (:require
   [garden.units :refer [px]]
   [garden.util :refer [space-join]]))

(def ^:private default-edge-size 16)

(defn px->str
  ;; TODO I thought one could use the following but the `CSSUnit` is not serialized as expected:
  ;; `(space-join [0 0 (px default-edge-size)])
  [p]
  (str p "px"))

(def ->width
  {1  "8.333333333333334%"
   2  "16.666666666666668%"
   3  "25%"
   4  "33.333333333333336%"
   5  "41.66666666666667%"
   6  "50%"
   7  "58.333333333333336%"
   8  "66.66666666666667%"
   9  "75%"
   10 "83.33333333333334%"
   11 "91.66666666666667%"
   12 "100%"})

(defn span
  [{:keys [span]}]
  {:width (->width span "auto")})

(defn- max-width-and-flex-basis
  [w]
  {:max-width w
   :flex      (space-join [0 0 w])})

(defn column
  [{:keys [span small medium large]}]
  (let [default-style {:padding (space-join [0 (px->str default-edge-size)])}]
    (cond
      (some? span)
      (merge
       default-style
       (max-width-and-flex-basis (->width span)))

      (or small medium large)
      (with-meta
        (merge
         default-style
         ;; Default (under 576px)
         (max-width-and-flex-basis "100%"))

        {:media
         {{:screen :only :min-width (px 320)}
          (max-width-and-flex-basis (->width small "100%"))

          {:screen :only :min-width (px 768)}
          ;; Reason for this `or`: from [0] paragraph "Mixed: mobile and desktop":
          ;; [0]: https://getbootstrap.com/docs/5.0/examples/grid/
          ;; > Each tier of classes scales up, meaning if you plan on setting the
          ;; > same widths for md, lg and xl, you only need to specify md.
          (max-width-and-flex-basis (->width (or medium small) "100%"))

          {:screen :only :min-width (px 992)}
          ;; Same reason for this `or` as above
          (max-width-and-flex-basis (->width (or large medium small) "960px"))}})

      :else
      ;; Default: parent width shared evenly among children
      (merge
       default-style
       {:flex 1}))))

(defn row
  [_props]
  {:display   "flex"
   :flex-wrap "wrap"
   :margin    (space-join [0 (px->str (* -1 default-edge-size))])})

(defn container
  [{:keys [breakpoint]
    ;; Defaut: `:small` sets a max-width at each responsive breakpoint
    :or   {breakpoint :xlarge}}]
  (with-meta
    {:margin-right "auto"
     :margin-left  "auto"
     ;; Fluid: sets `width: 100%` at all breakpoints
     :width        "100%"
     :padding      (space-join [0 (px->str (* -1 default-edge-size))])}
    {:media
     (when (not= breakpoint :fluid)
       (case breakpoint
         :small
         {{:screen :only :min-width (px 576)}  {:max-width (px 540)}
          {:screen :only :min-width (px 768)}  {:max-width (px 720)}
          {:screen :only :min-width (px 992)}  {:max-width (px 960)}
          {:screen :only :min-width (px 1200)} {:max-width (px 1140)}
          {:screen :only :min-width (px 1400)} {:max-width (px 1320)}}
         :medium
         {{:screen :only :min-width (px 768)}  {:max-width (px 720)}
          {:screen :only :min-width (px 992)}  {:max-width (px 960)}
          {:screen :only :min-width (px 1200)} {:max-width (px 1140)}
          {:screen :only :min-width (px 1400)} {:max-width (px 1320)}}
         :large
         {{:screen :only :min-width (px 992)}  {:max-width (px 960)}
          {:screen :only :min-width (px 1200)} {:max-width (px 1140)}
          {:screen :only :min-width (px 1400)} {:max-width (px 1320)}}
         :xlarge
         {{:screen :only :min-width (px 1200)} {:max-width (px 1140)}
          {:screen :only :min-width (px 1400)} {:max-width (px 1320)}}
         :xxlarge
         {{:screen :only :min-width (px 1400)} {:max-width (px 1320)}}))}))
  ;; TODO throw on other cases?))
